import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Card } from './../model/card';
import { CardsEventType } from './../cards.event.type';
import { EventTypes } from '../../../shared/EventTypes';

@Component({
	selector: 'app-data-cards',
	templateUrl: './data-cards.component.html',
	styleUrls: ['./data-cards.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class DataCardsComponent implements OnInit, OnDestroy {

	@Input() submited = false;
	@Input() cardData: Card;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() setTitle: EventEmitter<any> = new EventEmitter<any>();

	public form: FormGroup;
	private view = '[data-component="data-cards"]';
	public active: boolean = false;

	constructor(private formBuilder: FormBuilder) {
		this.form = formBuilder.group({
			'numCard': ['', Validators.compose([Validators.required, Validators.pattern(new RegExp(/[0-9]{4,4}/))])]
		});
	}

	ngOnInit() {
		AppEventDispatcher.listen(CardsEventType.STEPS.DATA_CARDS, data => {
			if (data.show) {
				this.setTitle.emit({
					title: 'Meus Cartões',
				});
				this.active = true;
				this.setForm.emit(this.form);
				this.show();
			} else {
				this.hide();
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(CardsEventType.STEPS.DATA_CARDS);
	}

	show() {
		TweenMax.delayedCall(.6, () => {
			const containerHeight = $(this.view).outerHeight() + $('.buttons').outerHeight() + 30;

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });
		});
	}

	hide() {
		this.active = false;
		TweenMax.delayedCall(.3, () => {
			AppEventDispatcher.dispatch(CardsEventType.STEPS.LIST_CARDS, { show: true });
		});
		
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="cards"] .content', show: active, delay: delay });
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/cards/data-cards/data-cards.component.ts